import wRgWoff2 from "./assets/fonts/ABBVoice/ABBvoice_W_Rg.woff2?url";
import wRgWoff from "./assets/fonts/ABBVoice/ABBvoice_W_Rg.woff?url";
import wRgTtf from "./assets/fonts/ABBVoice/ABBvoice_W_Rg.ttf?url";
import wRgEot from "./assets/fonts/ABBVoice/ABBvoice_W_Rg.eot?url";

import wLtWoff2 from "./assets/fonts/ABBVoice/ABBvoice_W_Lt.woff2?url";
import wLtWoff from "./assets/fonts/ABBVoice/ABBvoice_W_Lt.woff?url";
import wLtTtf from "./assets/fonts/ABBVoice/ABBvoice_W_Lt.ttf?url";
import wLtEot from "./assets/fonts/ABBVoice/ABBvoice_W_Lt.eot?url";

import wBdWoff2 from "./assets/fonts/ABBVoice/ABBvoice_W_Bd.woff2?url";
import wBdWoff from "./assets/fonts/ABBVoice/ABBvoice_W_Bd.woff?url";
import wBdTtf from "./assets/fonts/ABBVoice/ABBvoice_W_Bd.ttf?url";
import wBdEot from "./assets/fonts/ABBVoice/ABBvoice_W_Bd.eot?url";

import wMdWoff2 from "./assets/fonts/ABBVoice/ABBvoice_W_Md.woff2?url";
import wMdWoff from "./assets/fonts/ABBVoice/ABBvoice_W_Md.woff?url";
import wMdTtf from "./assets/fonts/ABBVoice/ABBvoice_W_Md.ttf?url";
import wMdEot from "./assets/fonts/ABBVoice/ABBvoice_W_Md.eot?url";

import abbIconsWoff2 from "./assets/fonts/abb-icons/abb-icons.woff2?url";
import abbIconsWoff from "./assets/fonts/abb-icons/abb-icons.woff?url";
import abbIconsSvg from "./assets/fonts/abb-icons/abb-icons.svg?url";
import abbIconsTtf from "./assets/fonts/abb-icons/abb-icons.ttf?url";
import abbIconsEot from "./assets/fonts/abb-icons/abb-icons.eot?url";

export function injectABBVoiceFont() {
  const style = document.createElement("style");
  style.textContent = `
    @font-face {
      font-family: "ABBVoice";
      font-style: normal;
      font-weight: normal;
      font-display: swap;
      src: url("${wRgWoff2}") format("woff2"),
           url("${wRgWoff}") format("woff"),
           url("${wRgTtf}") format("truetype"),
           url("${wRgEot}");
    }

    @font-face {
      font-family: "ABBVoice";
      font-style: normal;
      font-weight: 300;
      font-display: swap;
      src: url("${wLtWoff2}") format("woff2"),
           url("${wLtWoff}") format("woff"),
           url("${wLtTtf}") format("truetype"),
           url("${wLtEot}");
    }

    @font-face {
      font-family: "ABBVoice";
      font-style: normal;
      font-weight: bold;
      font-display: swap;
      src: url("${wBdWoff2}") format("woff2"),
           url("${wBdWoff}") format("woff"),
           url("${wBdTtf}") format("truetype"),
           url("${wBdEot}");
    }

    @font-face {
      font-family: "ABBVoice";
      font-style: normal;
      font-weight: 500;
      font-display: swap;
      src: url("${wMdWoff2}") format("woff2"),
           url("${wMdWoff}") format("woff"),
           url("${wMdTtf}") format("truetype"),
           url("${wMdEot}");
    }
  `;
  document.head.appendChild(style);
}

export function injectABBIconsFont() {
  const style = document.createElement("style");
  style.textContent = `
    @font-face {
      font-family: "abb-icons";
      src: url("${abbIconsWoff2}") format("woff2"),
           url("${abbIconsWoff}") format("woff"),
           url("${abbIconsSvg}") format("svg"),
           url("${abbIconsTtf}") format("truetype"),
           url("${abbIconsEot}") format("embedded-opentype");
      font-weight: normal;
      font-style: normal;
      font-display: block;
    }
  `;
  document.head.appendChild(style);
}
